/*
Controller: QuarterlyReportsProject

Operations:
  getQuarterlyReportsProjects
  createQuarterlyReportsProject
  getQuarterlyReportsProjectLogs
  createQuarterlyReportsPresignedUrl
*/
var Api = require('../config')
var QuarterlyReportsProjectRequestDef = require('../definitions/QuarterlyReportsProjectRequest')
var QuarterlyReportsPresignedUrlRequestDef = require('../definitions/QuarterlyReportsPresignedUrlRequest')

var QuarterlyReportsProject = (function () {
  /*
  Operation: getQuarterlyReportsProjects
  List quarterly reports projects
  Parameters:





  Responses:
    HTTP 200: Valid response
    HTTP 400: Input error
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function getQuarterlyReportsProjectsQuarterlyReportsProject (page, perPage, year, sortBy, sortDirection) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['year'] = year
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      var path = '/quarterlyReportsProject'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createQuarterlyReportsProject
  Create quarterly reports project
  Parameters:
    bodyRequest: Quarterly Reports Project Request
  Responses:
    HTTP 200: Valid response
    HTTP 400: Input error
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function createQuarterlyReportsProjectQuarterlyReportsProject (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        QuarterlyReportsProjectRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/quarterlyReportsProject'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getQuarterlyReportsProjectLogs
  Get quarterly reports project logs
  Parameters:

  Responses:
    HTTP 200: Valid response
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Project not found
  */
  function getQuarterlyReportsProjectLogsQuarterlyReportsProject (id) {
    return new Promise(function (resolve, reject) {
      try {
        if (!id) {
          throw new Error('id: Missing parameter')
        }
        if (id && !(typeof id === 'string')) {
          throw new Error('id: Wrong type: Got "' + (typeof id) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/quarterlyReportsProject/{id}/logs'
      path = path.replace('{' + 'id' + '}', id)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createQuarterlyReportsPresignedUrl
  Create quarterly reports pre-signed URLs
  Parameters:
    bodyRequest: Quarterly Reports Presigned URL Request
  Responses:
    HTTP 200: Valid response
    HTTP 400: Input error
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function createQuarterlyReportsPresignedUrlQuarterlyReportsProject (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        QuarterlyReportsPresignedUrlRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/quarterlyReportsProject/createPresignedUrl'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getQuarterlyReportsProjects'] = getQuarterlyReportsProjectsQuarterlyReportsProject
  ret['createQuarterlyReportsProject'] = createQuarterlyReportsProjectQuarterlyReportsProject
  ret['getQuarterlyReportsProjectLogs'] = getQuarterlyReportsProjectLogsQuarterlyReportsProject
  ret['createQuarterlyReportsPresignedUrl'] = createQuarterlyReportsPresignedUrlQuarterlyReportsProject
  return ret
})()

module.exports = QuarterlyReportsProject
